module.exports = __webpack_public_path__ + "assets/img/mobile_filter.7d688fe7.svg";